import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import SubscriptionPlanSetting from './components/SubscriptionPlanSetting';

const SubscriptionPlanManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="會員計費方案設定及管理"
          breadcrumbs={[
            {
              name: '會員管理',
            },
            {
              name: '會員計費方案設定及管理',
            },
          ]}
        />
        <SubscriptionPlanSetting />
      </Col>
    </Row>
  );
};

export default SubscriptionPlanManagement;
